import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Radio, SpacerVertical } from '@klarna/bubble-ui';

import { BusinessSize } from '@mjolnir/mf-fields-ts/src/enm/BusinessSize';
import { ErrorMessage } from '@/components/ErrorMessage';
import { getBpcPayload } from '@/selectors/bpc';

import { BusinessSizeLabel } from './BusinessSizeLabel';
import { BusinessSizeConfig } from '@mjolnir/mf-fields-ts/src/types/BusinessSizeConfig';

type BusinessSizeComponentProps = {
  value?: string;
  onChange: (value: string) => void;
  t: TranslatorFunction;
  error?: string;
} & BusinessSizeConfig;

export const _BusinessSizeComponent: React.FC<BusinessSizeComponentProps> = ({
  currency,
  rate,
  tiers,
  value,
  onChange,
  t,
  error,
}: BusinessSizeComponentProps): ReactElement => {
  const options = Object.keys(tiers || {}).map(tier => ({
    value: BusinessSize[tier], // Map the object key string back to the enum key,
    label: (
      <BusinessSizeLabel
        currency={currency}
        from={tiers[tier].from}
        to={tiers[tier].to}
        rate={rate}
        t={t}
      />
    ),
  }));

  return (
    <>
      {/* @ts-expect-error: FIXME */}
      <Radio error={error} onChange={onChange} value={value} options={options} />
      <SpacerVertical spaceToken="space/200" />
      {error ? <ErrorMessage message={error} /> : null}
    </>
  );
};

export const BusinessSizeComponent = connect(state => ({ payload: getBpcPayload(state) }))(
  _BusinessSizeComponent,
);
